import Image from "next/image";
import Container from "@/components/commons/Container";
import React from "react";
import { AspectRatio } from "@/v2-components/ui/aspect-ratio";
import { cn } from "@/libs/utils";
import { useTrans } from "@/utils/useTrans";

interface Feature {
  image: string;
  video?: string;
  header?: string;
  description: React.ReactNode;
}

const FeatureCards = ({
  features,
  className,
}: {
  features: Feature[];
  className?: string;
}) => {
  const { t } = useTrans(["tactsuit"]);

  return (
    <Container className={cn("max-w-screen-mdl text-coolgray-90", className)}>
      <div className="flex flex-col gap-y-16 laptop:gap-y-24">
        {features.map((feature: Feature, index) => (
          <div
            className="grid grid-cols-1 gap-6 laptop:grid-cols-2"
            key={index}
          >
            <div
              className={cn(
                "size-full",
                index % 2 === 1 ? "laptop:order-last" : "",
              )}
            >
              <AspectRatio ratio={1}>
                {feature.video ? (
                  <video
                    src={feature.video}
                    controls={false}
                    className="absolute size-full rounded-2xl object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                ) : (
                  <Image
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    src={feature.image}
                    alt="Person wearing VR headset"
                    className="rounded-2xl object-cover"
                    fill
                  />
                )}
              </AspectRatio>
            </div>
            <div className="flex flex-col justify-center rounded-l-lg text-start laptop:px-24">
              <h2 className="mb-4 text-3xl font-500 smd:font-400 laptop:text-5xl">
                {t(feature?.header ?? "")}
              </h2>
              <div className="whitespace-pre-line text-base">
                {feature.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default FeatureCards;
